module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Bold.woff2?42637ddc06c6bfd1c09fe2ab518005a6";